import { monthDayYear } from '@alltrails/shared/utils/timeHelpers';

const createReactClass = require('create-react-class');

const PhotoForTrailOrTrack = createReactClass({
  openLightbox(e) {
    e.preventDefault();
    this.props.openLightbox(this.props.index);
  },
  render() {
    const { photo } = this.props;
    if (!photo) {
      return null;
    }
    return (
      <div className="col-xs-12 col-sm-4 photo-tile">
        <div className="best-act">
          <div className="place rate">
            <div className="image xlate-none">
              <a className={photo.imageClass} onClick={this.openLightbox} rel="nofollow">
                <img src={photo.imageSrc} />
              </a>
            </div>
            <a className="photo-link link" href={photo.textLink}>
              {photo.text}
            </a>
            <div className="photo-location xlate-none">{photo.location}</div>
            <div className="photo-date xlate-none">{monthDayYear(photo.createdAt, this.props.languageRegionCode)}</div>
            <span className="stars floatleft clear hidden" dangerouslySetInnerHTML={{ __html: photo.ratingInputs }} />
          </div>
        </div>
      </div>
    );
  }
});

export { PhotoForTrailOrTrack };
